import { API } from 'aws-amplify'

import handleApiError from '@/utils/handle-api-error'

const ContactApis = {
  submit: async (name, email, phone, subject, message) =>
    API.post('user', '/contact', {
      body: {
        name,
        email,
        phone,
        subject,
        message,
      },
    }).catch(handleApiError),
}

export default ContactApis
